import React from 'react';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../../lng/en.json';
import ru from '../../lng/ru.json';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: en,
    },
    ru: {
      translation: ru,
    },
  },
  lng: 'en',
  fallbackLng: 'ru',
  interpolation: {
    escapeValue: false,
  },
});

export const changeLanguage = (lng) => {
  i18n.changeLanguage(lng);
};

const TranslationProvider = ({ children }) => {
  return <>{children}</>;
};

export default TranslationProvider;
